export const RESOURCE_TYPE_LABELS: Record<string, string> = {
  VirtualMachine: "Virtual Machine",
  Database: "Database",
  KubernetesCluster: "Kubernetes Cluster",
};
